const ru = {
  app: {
    title: "BeeApp",
    tagline: "Ассистент мастера по бровям",
  },
  linked: {
    eyebrow: "Способы входа",
    hint: "Свяжите Telegram и Google/Apple — это будет один аккаунт: те же покупки и история, где бы вы ни вошли. Если у второго способа уже есть свой аккаунт BeeApp, его покупки и история перенесутся сюда.",
    linked: "Привязан",
    notLinked: "Не привязан",
    link: "Привязать",
    waitTelegram: "Подтвердите в боте BeeApp («Объединить»). Код в сообщении бота должен совпадать:",
    waitGoogle: "В открывшемся браузере войдите через Google или Apple и подтвердите. Код на странице должен совпадать:",
    done: "Готово — аккаунты объединены.",
    errConflict: "Не получилось: к одному из аккаунтов уже привязан другой Telegram или Google. Напишите нам через «Сообщить о проблеме».",
    errGeneric: "Не получилось привязать. Попробуйте ещё раз.",
  },
  adminUsers: {
    grantTitle: "Выдать доступ",
    daysInput: "Дней",
    grantBtn_one: "Выдать на {{count}} день",
    grantBtn_few: "Выдать на {{count}} дня",
    grantBtn_many: "Выдать на {{count}} дней",
    grantBtn_other: "Выдать на {{count}} дней",
    granted: "Доступ выдан. Пользователю пришло сообщение в Telegram (если он там есть).",
    cancelTitle: "Отменить доступ",
    cancelAll: "Весь доступ",
    confirmRevoke: "Отменить «{{block}}» у {{name}} сейчас? Деньги этим не возвращаются — возврат делается в PayPal или bePaid.",
    confirmRevokeAll: "Отменить весь доступ у {{name}} сейчас? Деньги этим не возвращаются — возврат делается в PayPal или bePaid.",
    revokeYes: "Да, отменить",
    revoked: "Доступ отменён.",
    deleteBtn: "Удалить пользователя",
    confirmDelete: "Удалить {{name}} навсегда? Пропадут доступ, история подборов, переписка и прогресс. Записи об оплатах останутся. Это нельзя отменить.",
    deleteYes: "Да, удалить",
    deleted: "Пользователь удалён.",
    errDeleteAdmin: "Админа удалить нельзя — сначала снимите права (/deladmin в боте).",
    errDeleteSelf: "Себя удалить нельзя.",
    tab_users: "Пользователи",
    tab_calcs: "Расчёты",
    calcSearch: "№ расчёта, клиент или мастер",
    calcNotFound: "Расчёт №{{number}} не найден.",
    master: "мастер {{name}}",
    title: "Пользователи",
    menuDesc: "Кто пользуется приложением: доступ, оплаты, прогресс",
    chipSearch: "Поиск",
    chipProgress: "Прогресс",
    sumUsers: "всего",
    sumAccess: "с доступом",
    sumActive: "активны за 7 дн.",
    sumNew: "новые за 7 дн.",
    search: "Имя, @username, e-mail или Telegram ID",
    filter: "Фильтр",
    f_all: "Все",
    f_access: "С доступом",
    f_free: "Без покупок",
    f_expired: "Доступ закончился",
    f_new: "Новые",
    f_admins: "Админы",
    sortBy: "Сортировка:",
    s_activity: "по активности",
    s_created: "по регистрации",
    s_name: "по имени",
    found_one: "Найден {{count}}",
    found_few: "Найдено {{count}}",
    found_many: "Найдено {{count}}",
    found_other: "Найдено {{count}}",
    empty: "Никого не нашли.",
    more: "Показать ещё",
    admin: "Админ",
    hasAccess: "Доступ",
    expired: "Закончился",
    free: "Бесплатно",
    daysLeft_one: "{{count}} день",
    daysLeft_few: "{{count}} дня",
    daysLeft_many: "{{count}} дней",
    daysLeft_other: "{{count}} дней",
    until: "до {{date}}",
    paid: "Оплачено",
    selections: "Подборов",
    lessons: "Уроков пройдено",
    messages: "Сообщений Ане",
    worksShort_one: "{{count}} работа",
    worksShort_few: "{{count}} работы",
    worksShort_many: "{{count}} работ",
    worksShort_other: "{{count}} работ",
    signIn: "Способы входа: TG — Telegram, G — Google/Apple",
    minAgo: "{{count}} мин назад",
    hAgo: "{{count}} ч назад",
    dAgo: "{{count}} дн назад",
    joined: "В приложении с {{date}}",
    lastMessage: "последнее сообщение {{when}}",
    chapters: "Прогресс по главам",
    chapterLine: "пройдено {{done}} · начато {{started}} из {{total}}",
    intro: "Введение",
    accessHistory: "История доступа",
    payments: "Оплаты",
    recentSelections: "Последние подборы",
    noClientName: "без имени клиента",
    src_paypal: "PayPal",
    src_bepaid: "карта",
    src_bepaid_link: "карта по ссылке",
    src_invite: "приглашение",
    src_admin_grant: "выдал админ",
  },
  auth: {
    linkTitle: "Объединить аккаунты?",
    linkText: "Google-аккаунт «{{google}}» станет одним аккаунтом с Telegram-аккаунтом «{{telegram}}»: покупки и история объединятся, входить можно будет и так, и так.",
    linkYes: "Да, объединить",
    linkDone: "Готово — аккаунты объединены. Вернитесь в Telegram.",
    telegramLogin: "Войти через Telegram",
    googleFromTelegram: "Войти через Google или Apple",
    googleFromTelegramHint: "Откроется браузер: войдите там и подтвердите вход — приложение в Telegram войдёт в этот аккаунт.",
    telegramAccountHint: "Аккаунт вашего Telegram — с покупками, сделанными в приложении.",
    waitTelegramTitle: "Подтвердите вход в Telegram",
    waitTelegramText: "Откройте бота BeeApp и нажмите «Войти». Код в сообщении бота должен совпадать:",
    waitGoogleTitle: "Подтвердите вход в браузере",
    waitGoogleText: "Войдите в браузере через Google или Apple и подтвердите. На странице должен быть этот же код:",
    openTelegram: "Открыть Telegram",
    openBrowserAgain: "Открыть браузер ещё раз",
    waiting: "Ждём подтверждения…",
    cancel: "Отмена",
    loginExpired: "Время на вход истекло или вход отменён. Попробуйте ещё раз.",
    approveEyebrow: "Вход в Telegram",
    approveTitle: "Войти в BeeApp в Telegram под этим аккаунтом?",
    approveAs: "Аккаунт:",
    approveDevice: "Запрос с устройства: {{device}}",
    approveCheck: "В Telegram должен быть показан код",
    approveWarn: "Подтверждайте, только если вы сами только что нажали «Войти через Google» в BeeApp в Telegram и код совпадает. Если ссылку прислал кто-то другой — нажмите «Это не я».",
    approveYes: "Да, войти в Telegram",
    approveNo: "Это не я",
    approveDone: "Готово! Вернитесь в Telegram — приложение уже вошло в этот аккаунт.",
    approveDeclined: "Вход отменён.",
    approveNeedGoogle: "Подтвердить можно только из аккаунта Google или Apple. Выйдите и войдите через Google или Apple.",
    approveLogout: "Выйти и войти через Google",
    login: "Войти",
    register: "Регистрация",
    createAccount: "Создать аккаунт",
    welcomeBack: "С возвращением!",
    orContinueWithEmail: "Или через email",
    alreadyHaveAccount: "Уже есть аккаунт? Войти",
    dontHaveAccount: "Нет аккаунта? Регистрация",
    playAsGuest: "Продолжить как гость",
    emailPlaceholder: "Email адрес",
    passwordPlaceholder: "Пароль",
    confirmPasswordPlaceholder: "Повторите пароль",
    passwordsDoNotMatch: "Пароли не совпадают",
    googleLogin: "Google",
    appleLogin: "Apple",
    guestLoginFailed: "Ошибка гостевого входа",
    errGeneric: "Не удалось войти. Попробуйте ещё раз.",
    errPopupBlocked: "Браузер заблокировал окно входа. Разрешите всплывающие окна и попробуйте снова.",
    errUnauthorizedDomain: "Вход с этого домена не разрешён. Напишите в поддержку.",
    errNetwork: "Нет связи с сервером. Проверьте интернет и попробуйте снова.",
    errProviderDisabled: "Этот способ входа временно недоступен.",
    forgotPassword: "Забыли пароль?",
    resetInstructions: "Введите email — мы пришлём ссылку для сброса пароля.",
    enterEmailForReset: "Введите email для сброса пароля",
    sendResetEmail: "Отправить ссылку",
    resetEmailSent: "Письмо отправлено! Проверьте почту.",
    backToLogin: "Назад",
    terms: "Продолжая, вы соглашаетесь с Условиями использования и Политикой конфиденциальности.",
  },
  maintenance: {
    title: "Технические работы",
    body: "Приложение на техническом обслуживании. Скоро вернёмся!",
  },
  adminSettings: {
    title: "Настройки приложения",
    menuDesc: "Разделы, цены подписки, лимиты и режим обслуживания",
    sectionsChip: "Разделы",
    pricesChip: "Цены",
    save: "Сохранить настройки",
    saved: "Настройки сохранены",
    sections: "Разделы приложения",
    sectionsHint: "Выключенный раздел остаётся в меню, но помечен «Скоро» и не открывается. У вас как у администратора все разделы работают всегда.",
    section_selection: "Подбор",
    section_study: "Уроки и упражнения",
    section_history: "Прошлые подборы",
    section_games: "Тренажёры",
    section_chat: "Чат с Аней",
    plans: "Планы и цены",
    plansHint: "Цена 0 показывается как «Скоро» — план виден, но без суммы. Оплата пока проходит через вас: клиент пишет в Telegram, вы выдаёте доступ на нужное число дней.",
    currency: "Валюта",
    addPlan: "Добавить план",
    newPlan: "Новый план",
    planTitleRu: "Название (RU)",
    planTitleEn: "Название (EN)",
    planPrice: "Цена",
    planPriceUsd: "Цена (EN-версия)",
    currencyEn: "Валюта в английской версии",
    bynRate: "Курс для bePaid: BYN за 100 ₽",
    bynRateHint: "bePaid списывает белорусские рубли: цена в ₽ × курс / 100, округлённо до целого. Курс НБ РБ на 28.10.2026 — 3,66.",
    planDays: "Дней доступа",
    planBadgeRu: "Плашка (RU)",
    planBadgeEn: "Плашка (EN)",
    planGrants: "Открывает при онлайн-оплате, дней (пусто — не входит)",
    planGrantsHint: "Оплата на сайте через PayPal списывает цену в $ и выдаёт эти блоки на указанные дни.",
    planGrantsEmpty: "Ничего не выбрано — тариф нельзя купить онлайн, карточка ведёт к администратору.",
    browserCheckout: "Оплата в браузере из Telegram",
    browserCheckoutHint: "В приложении в Telegram у тарифов кнопка «Оплатить в браузере»: сайт откроется с уже выполненным входом. Правила Telegram требуют продавать цифровые товары в Mini App за Stars — если Telegram потребует, выключите здесь.",
    planTier: "Тариф (сроки одного тарифа — одна карточка; выше по списку — апгрейд с зачётом)",
    planTierNone: "— отдельная карточка",
    planTierFeedback: "обратная связь",
    upgradeCredit: "Зачёт при переходе на тариф выше",
    upgradeCreditHint: "При переходе на отмеченный тариф неиспользованные оплаченные дни текущего тарифа вычитаются из цены, а новый тариф начинается сегодня. На неотмеченный — полная цена, оплаченные дни сохраняются и новый срок добавляется к ним.",
    upgradeCredit_challenge: "С MIXES на CHALLENGE + MIXES",
    upgradeCredit_feedback: "На CHALLENGE + MIXES + обратная связь",
    pricingNotice: "Уведомление о стартовых ценах",
    pricingNoticeOn: "Показывать над тарифами",
    pricingNoticeHint: "Плашка «Цены запуска» на странице тарифов и пометка в окне оплаты. Выключите, когда цены поднимутся.",
    planPayLink: "Ссылка на оплату bePaid (оплату подтверждаете вы в «Оплаты онлайн»; пусто — без кнопки)",
    planActive: "Показывать в приложении",
    planZeroPrice: "Цена не указана — будет показано «Скоро»",
    planDelete: "Удалить план",
    limits: "Бесплатные лимиты",
    courses: "Курсы",
    coursesHint: "Закрытый курс заблокирован для всех, кроме админов: уроки не открываются, их содержимое API не отдаёт. Вы сами видите такой курс целиком — чтобы проверить его до запуска.",
    course_base_hint: "Бумага, штрихи и схемы — идут по основной подписке.",
    course_ombre_hint: "Работа с Подбором и Теория. Продаётся отдельно; включайте, когда уроки будут дозаписаны.",
    freeSelections: "Бесплатных подборов",
    freeSelectionsHint: "Сколько расчётов доступно без подписки. 0 — подбор только по подписке.",
    freeLessons: "Бесплатных уроков в главе",
    freeLessonsHint: "Сколько первых уроков КАЖДОЙ главы открыты без подписки. Работы в них сдавать нельзя. 0 — всё по подписке.",
    announcement: "Объявление",
    announcementOn: "Показывать объявление",
    announcementHint: "Короткая строка вверху главного меню.",
    announcementRu: "Текст объявления (RU)",
    announcementEn: "Текст объявления (EN)",
    service: "Контакт и обслуживание",
    contact: "Telegram для связи",
    contactHint: "Ник без @ или с @ — покажем клиентам рядом с планами подписки.",
    maintenance: "Режим обслуживания",
    maintenanceHint: "Все, кроме администраторов, увидят экран-заглушку.",
    maintenanceWarning: "Внимание: после сохранения приложение будет закрыто для всех пользователей, кроме администраторов.",
    maintenanceRu: "Сообщение (RU)",
    maintenanceEn: "Сообщение (EN)",
  },
  menu: {
    greeting: "Добро пожаловать",
    continueTitle: "Продолжить просмотр",
    lessonN: "Урок {{n}}",
    startSelection: "Начать подбор",
    startSelectionDesc: "Пошаговый подбор пигмента, картриджа и схемы укладки",
    study: "Уроки и упражнения",
    studyDesc: "Видеоуроки и задания с обратной связью от Ани",
    lessonsChip: "Уроки",
    history: "Прошлые подборы",
    historyDesc: "Сохранённые расчёты по клиентам · поиск по имени и дате",
    games: "Тренажёры",
    gamesDesc: "Викторина по курсу и тренажёр штрихов для отработки движений",
    findUs: "Найти нас",
    findUsDesc: "Соцсети и сайт Bee Company",
    logout: "Выйти",
    lockedLessons: "Часть уроков заблокирована",
    learnSubscription: "Нажмите, чтобы узнать о подписке",
    sectionSoon: "Скоро",
  },
  selection: {
    calcNumber: "Расчёт №{{number}}",
    calcNumberHint: "Если что-то показалось неверным — назовите этот номер, и мы найдём именно этот расчёт.",
    title: "Подбор",
    step: "Шаг",
    of: "из",
    back: "Назад",
    next: "Далее",
    finish: "Получить результат",
    toMainMenu: "В главное меню",
    restart: "Начать заново",
    summary: "Сводка",
    required: "Выберите вариант на каждом пункте, чтобы продолжить.",
    mixRequired: "Сначала выберите один рабочий микс из трёх вариантов.",
    schemeRequired: "Выберите схему укладки, чтобы перейти к подбору картриджа.",
    cartridgeRequired: "Выберите тип кожи — без него нельзя подобрать картридж и сформировать отчёт.",
    quotaLeft: "Осталось бесплатных подборов",
    limitReached: "Лимит бесплатных подборов исчерпан (5). Оформите премиум для безлимитного доступа — обратитесь к администратору.",
    review: "Проверьте параметры и запустите подбор.",
    notSet: "—",
    s1Title: "Выбор пигмента",
    pigmentMineral: "Минеральный пигмент",
    pigmentHybrid: "Гибридный пигмент",
    s2Title: "Подобрать микс",
    skinDepth: "Тон кожи",
    depthFair: "Очень светлая",
    depthLight: "Светлая",
    depthOlive: "Загорелая",
    depthTan: "Смуглая",
    depthDark: "Тёмная",
    skinTone: "Подтон кожи",
    skinToneCold: "Холодный",
    skinToneWarm: "Тёплый",
    skinToneNeutral: "Нейтральный",
    oldPermanent: "Старый перманент (цвет остатка)",
    pmu_none: "Нет старого перманента",
    pmu_gray: "Серый",
    pmu_green: "Зелёный (с белым)",
    pmu_yellow: "Жёлтый",
    pmu_orange: "Оранжевый",
    pmu_salmon: "Лососевый",
    pmu_red: "Красный",
    pmu_violet: "Фиолетовый",
    yes: "Есть",
    no: "Нет",
    eyeColor: "Цвет глаз",
    zoomHint: "Удерживайте фото, чтобы увеличить",
    eye_brown: "Карие",
    eye_copper_brown: "Медно-карие",
    eye_green: "Зелёные",
    eye_blue: "Голубые",
    eye_gray: "Серые",
    irisMarker: "Вкрапления в радужке",
    irisMarkerHint: "Отдельно отметьте маркер внутри карей или медной радужки",
    irisMarker_none: "Нет зелёных вкраплений",
    irisMarker_green: "Зелёные",
    irisMarker_yellow_green: "Жёлто-зелёные",
    hairColor: "Цвет волос",
    couperose: "Купероз (сосудистая сетка)",
    couperoseHint: "Пример купероза — удерживайте фото, чтобы увеличить",
    hairRed: "Рыжие",
    hairBlonde: "Светлые",
    hairBrown: "Русые",
    hairChestnut: "Каштановые",
    hairBlack: "Тёмные",
    desiredDepth: "Насколько тёмными сделать брови?",
    desiredDepthHint: "Для этого типажа глубина добавляется отдельным минеральным проходом",
    desiredDepth_natural: "Натуральная глубина",
    desiredDepth_dark: "Сделать темнее",
    s3Title: "Подобрать картридж",
    skinDensity: "Тип кожи",
    densityDensePorous: "Плотная / пористая",
    densityThinDry: "Тонкая / сухая",
    densityDense: "Плотная",
    densityPorous: "Пористая",
    densityThin: "Тонкая",
    densityDry: "Сухая",
    s4Title: "Схема укладки",
    hairPresence: "Состояние волосков",
    hairHas: "Есть волоски — хороший рост волоска",
    hairNone: "Нет волосков",
    hairPartial: "Частично отсутствуют в теле брови",
    hairOverplucked: "Перещипанные",
    hairDense: "Густые",
    hairStiff: "Жёсткие",
    hairType: "Структура волоска",
    hairTypeStiff: "Жёсткий",
    hairTypeSoft: "Мягкий",
    hairGrowth: "Направление роста волосков",
    hairGrowthNormal: "Обычное",
    hairGrowthDown: "Растут вниз в теле и хвосте",
    desiredEffect: "Желаемый результат",
    desiredEffectHint: "Схему укладки выбирает пожелание клиента",
    effectAiry: "Лёгкие воздушные",
    effectDefined: "Чёткие, с очерченным низом",
    pickMix: "Подобрать микс",
    mixReady: "Выберите рабочий микс",
    mixNeutral: "Базовый — нейтральный",
    mixWarm: "Теплее",
    mixLight: "Светлее",
    mixNeutralWhy: "Сбалансированный повседневный вариант для натурального результата.",
    mixWarmWhy: "Более тёплый оттенок: на 2 капли больше тёплого пигмента (№11 Espresso, в минерале — №9), без разбавителя.",
    mixLightWhy: "Светлее и мягче: на каплю разбавителя больше.",
    hybridBrightPressure: "Пометка мастеру: с гибридным миксом работайте с очень лёгким нажимом. Чем плотнее укладка, тем меньше нажим с каждым проходом.",
    coverupFirstHint: "Сначала выполните перекрытие старого перманента — поэтому этот микс показан первым.",
    chooseThisMix: "Работать этим миксом",
    mixSelected: "Выбран",
    continueToScheme: "Продолжить",
    schemeHelpTitle: "Помочь с выбором схемы укладки?",
    schemeHelpText: "Можно выбрать способ работы из схем курса или пропустить этот этап и перейти к картриджу.",
    schemeGroupClosed: "Нажмите, чтобы увидеть варианты",
    schemeGroupOpen: "Выберите один из вариантов ниже",
    schemeGroupChosen: "Вариант выбран — нажмите, чтобы изменить",
    chooseScheme: "Выбрать схему",
    skipScheme: "Пропустить",
    manualSchemeHint: "Выберите схему по запросу клиента и тому, как вы хотите работать. В подсказках учтён рост волосков.",
    schemeGroupDefined: "Чёткий низ — лёгкий верх",
    schemeGroupGraphics: "Графика",
    schemeFastFluffy: "Быстрые пушистые",
    schemeFastFluffyDesc: "Быстрая клиентская техника: плотный низ и пушистый верх. Лучше при хорошем или густом росте волосков, который поддерживает нижнюю границу.",
    schemeClassic: "Классическая укладка",
    schemeClassicDesc: "Классический градиент с акцентом в изломе. Подходит при обычном направлении роста и достаточном количестве волосков.",
    schemeDecorativeBottom: "Декоративный чёткий низ",
    schemeDecorativeBottomDesc: "Выраженная нижняя треть и лёгкий верх. Для декоративного запроса; чёткий низ лучше выбирать, когда волоски не отсутствуют.",
    schemeDecorativeGraphics: "Декоративная графика",
    schemeDecorativeGraphicsDesc: "Графика по секторам: плотный хвост и воздушное начало. Направление естественного роста учитывайте при построении формы.",
    schemeSoftGraphics: "Мягкая графика",
    schemeSoftGraphicsDesc: "Мягкая управляемая графика с наслоением 50/50; контур закрепляется в конце. Подходит для более деликатной формы.",
    schemeBorderless: "Без чётких границ",
    schemeBorderlessDesc: "Мягкая бровь с акцентом в середине, без контуров. Урок по схеме — в результате подбора.",
    schemeLadyPlus: "Леди +",
    schemeLadyPlusDesc: "Деликатная неширокая форма 50+: акцент в центре и продолжение естественного роста волосков.",
    schemeAsian: "Азиатская",
    schemeAsianDesc: "Для волосков, растущих вниз в теле и хвосте: невесомое начало, акцент в середине и активный излом.",
    schemeLessonMissing: "Урок для этой схемы пока не найден.",
    chosenScheme: "Выбранная схема",
    schemeSkipped: "Пропущена",
    schemeChoice_fast_fluffy: "Быстрые пушистые",
    schemeChoice_classic: "Классическая укладка",
    schemeChoice_decorative_bottom: "Декоративный чёткий низ",
    schemeChoice_decorative_graphics: "Декоративная графика",
    schemeChoice_soft_graphics: "Мягкая графика",
    schemeChoice_borderless: "Без чётких границ",
    schemeChoice_lady_plus: "Леди +",
    schemeChoice_asian: "Азиатская",
    pickCartridge: "Подобрать картридж",
    fullReport: "Получить полный отчёт",
    resultTitle: "Результат подбора",
    predictedColors: "Прогнозируемый цвет",
    yourMix: "Ваш микс",
    badgeMain: "Основной",
    badgeAlt: "Альтернатива",
    badgeCoverup: "Перекрытие",
    ratio: "Пропорция",
    totalDrops: "Всего:",
    dropsShort: "кап.",
    copyMix: "Скопировать микс",
    copyShort: "Копировать",
    resultUntitled: "Рецепт процедуры",
    tileMix: "Микс",
    tileScheme: "Схема",
    tileSchemeSkipped: "Не выбрана",
    stepCoverup: "Сначала · перекрытие",
    stepWorkingMix: "Затем · рабочий микс",
    cartridge: "Картридж",
    ruleApplied: "Сработало экспертное правило",
    finishPass: "Финишный проход",
    purePigment: "чистый пигмент",
    layupScheme: "Схема укладки — штрихи",
    layupStyle: "Стиль",
    schemeLessonLabel: "Урок по этой схеме",
    schemeLessonLocked: "Урок по подписке — открыть тарифы",
    layupComing: "Наглядная схема укладки (анимация от Ани) скоро появится здесь.",
    whyTitle: "Почему именно это",
    pass: "Проход",
    careTitle: "Рекомендации по уходу для клиента",
    watchVideo: "Смотреть видео",
    clientName: "Имя клиента",
    clientNamePlaceholder: "Например: Анна П.",
    clientNameHint: "Необязательно. Поможет найти этот расчёт позже.",
    shareClient: "Отправить клиенту",
    shareHeader: "Уход за бровями после процедуры",
    copied: "Скопировано!",
  },
  history: {
    title: "Прошлые подборы",
    searchName: "Имя клиента или № расчёта",
    searchChip: "Поиск",
    dateChip: "По дате",
    dateFrom: "С даты",
    dateTo: "По дату",
    clear: "Сбросить",
    unnamed: "Без имени",
    emptyTitle: "Пока пусто",
    emptyHint: "Сохранённые подборы появятся здесь после первого расчёта.",
    emptyFiltered: "Ничего не найдено по заданным фильтрам.",
  },
  games: {
    title: "Тренажёры",
    intro: "Закрепите материал курса и отработайте движения аппаратом в игровой форме.",
    backToGames: "К тренажёрам",
    quiz: {
      title: "Викторина",
      desc: "Проверьте знания по курсу: пигменты, картриджи, техника и уход.",
      chip: "Викторина",
      question: "Вопрос",
      next: "Дальше",
      finish: "Завершить",
      again: "Ещё раз",
      great: "Отличный результат!",
      keepGoing: "Продолжайте практиковаться!",
    },
    stroke: {
      title: "Тренажёр штрихов",
      desc: "Обведите траекторию движения аппарата: маятник, веер, диагонали.",
      chip: "Движения",
      draw: "Проведите пальцем по пунктиру",
      retry: "Заново",
      tip: "Старайтесь вести линию плавно и точно по пунктиру, не отрывая палец.",
    },
  },
  study: {
    title: "Уроки и упражнения",
    free: "Бесплатно",
    locked: "Заблокировано",
    available: "Доступно",
    open: "Открыть",
    demo: "Демо-урок",
    templates: "Шаблоны для печати",
    templatesHint: "Распечатайте и натяните латекс сверху — по ним отрабатываются движения.",
    template_blocks: "Квадраты и растяжки",
    template_blocks_for: "Для главы «Штрихи»",
    template_brows: "Контуры бровей",
    template_brows_for: "Для главы «Схемы»",
    templateOpen: "Открыть",
    templateCopy: "Ссылка",
    templateCopied: "Скопировано",
    unlock: "Открыть по подписке",
    feedbackTitle: "Обратная связь от Ани",
    feedbackPlaceholder: "Опишите вашу работу или задайте вопрос…",
    submit: "Отправить",
    submitted: "Отправлено",
    anyaReply: "Ответ Ани",
    status_not_started: "Не начато",
    status_in_progress: "В процессе",
    status_submitted: "На проверке",
    status_reviewed: "Проверено",
    status_done: "Завершено",
    lessons: "уроков",
    exercises: "заданий",
    progress: "Ваш прогресс",
    comingSoon: "Скоро",
    sectionPaper: "Бумага",
    sectionStrokes: "Штрихи",
    sectionSchemes: "Схемы",
    sectionSelection: "Работа с Подбором",
    sectionTheory: "Теория",
    course_base: "CHALLENGE — курс",
    course_ombre: "Омбре Броус",
    courseClosedHint: "Отдельный курс — покупается дополнительно. Уроки ещё записываются, откроем совсем скоро.",
  },
  achv: {
    gotIt: "Отлично!",
    lessonDoneTitle: "Урок завершён!",
    passedTitle: "Урок пройден!",
    passedMsg: "Аня зачла вашу работу",
    retryTitle: "Почти получилось!",
    retryMsg: "Аня оставила отзыв — попробуйте ещё раз",
  },
  review: {
    title: "Проверка заданий",
    menuDesc: "Работы студентов на проверку: принять или вернуть с отзывом",
    pending: "На проверке",
    approve: "Принять",
    decline: "Вернуть",
    feedbackChip: "Отзыв",
    feedbackPlaceholder: "Отзыв студенту: что хорошо, что доработать…",
    emptyTitle: "Всё проверено!",
    emptyHint: "Новые работы появятся здесь автоматически.",
  },
  exercise: {
    heading: "Задание",
    whatToSubmit: "Что прислать",
    selectPhoto: "Выбрать фото",
    submitWork: "Отправить работу",
    resubmit: "Отправить повторно",
    underReview: "Работа отправлена на проверку. Аня проверит её и даст обратную связь.",
    sendWork: "Отправить работу на проверку",
    workSent: "Работа отправлена! Следите за ответом в чате с Аней.",
    discussInChat: "Вопросы и обсуждение — в чате с Аней.",
    subscriptionToSubmit: "Проверка работ — по подписке",
    subscriptionToSubmitHint: "Это демо-урок: его можно смотреть и читать, а сдать работу Ане — по подписке.",
    openPlans: "Посмотреть тарифы",
    example: "Пример выполненной работы",
    passed: "🎉 Задание зачтено! Отличная работа.",
    deadlinePassed: "Срок истёк",
    daysLeft: "{{count}} дн. осталось",
    deadlineAfterSubmit: "Срок: {{days}} дн. после отправки",
    chat: "Чат с Аней",
    chatEmpty: "Задайте вопрос — Аня ответит",
    chatPlaceholder: "Написать Ане…",
    chatPlaceholderUnified: "Вопрос или фото работы…",
    chatEmptyUnified: "Задайте вопрос Ане или пришлите фото работы на проверку — всё в одном чате.",
    statusSubmitted: "На проверке",
    statusPassed: "Зачтено",
    statusFailed: "Доработать",
  },
  quizStats: {
    title: "Статистика викторины",
    menuDesc: "Все вопросы и как на них отвечают",
    overall: "Всего по викторине",
    correct: "верных",
    answers: "ответов",
    noAnswers: "нет ответов",
    totalAnswers: "Всего ответов",
  },
  access: {
    title: "Доступ к блокам",
    none: "нет доступа",
    notOwned: "нет доступа",
    daysLeft: "осталось {{count}} дн.",
    days: "На сколько дней продлить",
    hint: "Отмеченные блоки продлеваются на указанное число дней, снятые — отзываются. Дни добавляются к остатку, а не начинают отсчёт заново.",
    apply: "Применить",
    saved: "Доступ обновлён",
    legacyGrant: "У пользователя старая выдача «премиум на всё», сделанная до разделения на блоки. Если снять один блок, остальные сохранятся на тот же срок.",
  },
  lessonActions: {
    sendWork: "Отправить работу",
    askQuestion: "Задать вопрос",
    noFeedbackTitle: "Проверка работ и чат — в подписке с обратной связью",
    noFeedbackHint: "На вашей подписке уроки открыты полностью, но работы Аня не проверяет и в чат ответить не сможет. Проверка и чат подключаются отдельно.",
    seePlans: "Посмотреть тарифы",
  },
  chat: {
    attach: "Прикрепить фото",
    tooLarge: "Файл слишком большой. Попробуйте фото меньшего размера.",
    askAboutLesson: "Задать вопрос по уроку",
    askingAbout: "Вопрос по уроку",
    returnToLesson: "К уроку",
    title: "Чат с Аней",
    menuDesc: "Вопросы и работы на проверку — всё в одном чате",
    placeholder: "Сообщение или фото…",
    empty: "Напишите Ане или пришлите фото работы — она ответит здесь.",
    lockedTitle: "Чат с Аней — в подписке с обратной связью",
    lockedHint: "Переписка с Аней и проверка работ входят в тариф «CHALLENGE + MIXES + обратная связь» — с ним можно писать Ане и отправлять работы на проверку.",
    lockedEmpty: "Здесь будет ваша переписка с Аней.",
    adminTitle: "Чаты",
    adminMenuDesc: "Переписка с участниками — вопросы и работы",
    noChats: "Пока нет переписок",
    participants: "Участники",
    pending: "на проверке",
    userId: "ID",
    noIdentifiers: "без Telegram и e-mail",
  },
  account: {
    pendingCount: "{{count}} ожидают внимания",
    title: "Профиль",
    subscription: "Подписка",
    noSubscription: "Нет подписки",
    active: "Активна",
    expired: "Истекла",
    cancelled: "Отменена",
    activeUntil: "Действует до",
    expiredOn: "Истекла",
    daysLeft: "дн. осталось",
    remaining: "осталось",
    grantedByAdmin: "Выдана администратором",
    unlockAll: "Открыть все уроки",
    unlockAllDesc: "MIXES — миксы и подбор игл, CHALLENGE — курс, индивидуальная обратная связь: выберите тариф ниже",
    plans: "Планы подписки",
    plan1m: "1 месяц",
    plan3m: "3 месяца",
    plan6m: "6 месяцев",
    bestValue: "Выгоднее всего",
    comingSoon: "Скоро",
    paymentSoon: "Оплата скоро будет доступна — следите за обновлениями!",
    memberSince: "С нами с",
    renewContact: "Для продления обратитесь к администратору",
    expiresWarning: "Подписка истекает через",
    daysAbbr: "дн.",
    contactToBuy: "Для оформления подписки напишите",
  },
  inbox: {
    title: "Входящие",
    menuDesc: "Вопросы студентов и работы на проверку",
    questions: "Вопросы",
    works: "Работы",
    chatEmpty: "Пока нет сообщений в чате",
    noQuestions: "Новых вопросов нет 🎉",
    noWorks: "Работ на проверку нет 🎉",
    replyPlaceholder: "Ваш ответ студенту…",
    sendReply: "Ответить",
    noteOrReply: "Комментарий / сообщение студенту…",
    sendMessageOnly: "Отправить сообщение",
    pass: "Зачесть",
    passed: "Зачтено",
    needsWork: "Доработать",
    fail: "На доработку",
  },
  admin: {
    whatToGrant: "Что открыть (по умолчанию — всё)",
    pickBlock: "Выберите хотя бы один блок",
    pendingSaved: "{{name}} ещё не открывал(а) приложение — выдача сохранена: {{blocks}}. Активируется при первом входе, отсчёт дней начнётся тогда же. Сгорит {{until}}.",
    title: "Администратор",
    grantTitle: "Выдать премиум",
    grantDesc: "Премиум открывает все уроки и безлимитный подбор. Укажите @username, email (для входа через Google) или Telegram ID клиента и срок в днях.",
    targetPlaceholder: "@username, email или Telegram ID",
    daysPlaceholder: "Дней",
    grantBtn: "Выдать премиум",
    granted: "Премиум выдан",
    notFound: "Пользователь не найден",
    invalid: "Укажите пользователя и срок в днях",
  },
  common: {
    loading: "Загрузка…",
    error: "Что-то пошло не так",
    soon: "Скоро",
    theme: "Тема",
  },
  invite: {
    adminTitle: "Пригласительные ссылки",
    menuDesc: "Одноразовые ссылки с доступом — для новых и уже зарегистрированных",
    chipLink: "Ссылка",
    createTitle: "Новая ссылка",
    createHint: "Выберите, что откроет ссылка и на сколько дней. Сработает один раз — у первого, кто её откроет, в Telegram или в браузере. Если человек ещё не зарегистрирован, доступ появится сразу после входа.",
    blocks: "Что открыть",
    accessDays: "Доступ, дней",
    validDays: "Ссылка действует, дней",
    days: "{{count}} дн.",
    note: "Метка (видна только вам)",
    notePlaceholder: "Например: Мария, оплата 14.10",
    rulesHint: "Дни доступа считаются с момента активации. Неиспользованная ссылка сгорит через {{count}} дн.",
    create: "Создать ссылку",
    created: "Ссылка готова — отправьте её",
    linkTelegram: "Для Telegram — активируется прямо в боте",
    linkWeb: "Для браузера — после входа через Google или Apple",
    copy: "Копировать",
    copied: "Скопировано",
    copyFailed: "Не вышло",
    shareTelegram: "Отправить в Telegram",
    shareText: "Ваше приглашение в BeeApp — откройте ссылку, чтобы активировать доступ:",
    noBot: "Ссылку для Telegram сейчас не получить: бот не ответил. Ссылка для браузера работает.",
    listTitle: "Созданные ссылки",
    filterActive: "Активные",
    filterAll: "Все",
    empty: "Ссылок пока нет.",
    emptyActive: "Активных ссылок нет.",
    redeemedCount: "Использовано ссылок: {{count}} — см. «Все».",
    revoke: "Отменить ссылку",
    revokeConfirm: "Отменить ссылку? Открыть её больше никто не сможет.",
    redeemedBy: "{{who}}, {{date}} ({{via}})",
    viaWeb: "браузер",
    validUntil: "действует до {{date}}",
    createdOn: "создана {{date}}",
    status: {
      active: "Активна",
      redeemed: "Использована",
      expired: "Истекла",
      revoked: "Отменена",
    },
    loginTitle: "Вам открыт доступ",
    loginHint: "Войдите, чтобы активировать его на своём аккаунте.",
    okTitle: "Приглашение активировано",
    alreadyTitle: "Приглашение уже ваше",
    okMessage: "Открыто: {{blocks}} — на {{count}} дн.",
    failTitle: "Приглашение не сработало",
    err: {
      INVITE_NOT_FOUND: "Ссылка-приглашение не найдена. Проверьте, что она скопирована целиком.",
      INVITE_USED: "Эта ссылка уже использована. Попросите новую у администратора.",
      INVITE_EXPIRED: "Срок действия ссылки истёк. Попросите новую у администратора.",
      INVITE_REVOKED: "Эта ссылка отменена администратором.",
      INVITE_ADMIN: "Вы администратор — доступ у вас и так полный. Ссылка осталась неиспользованной.",
      generic: "Не удалось активировать приглашение.",
    },
  },
  pay: {
    eyebrow: "Оплата",
    choosePlan: "Выберите тариф ниже — оплата через PayPal или картой",
    renewOnline: "Продлить можно ниже — через PayPal или картой.",
    tapToBuy: "Нажмите на тариф, чтобы оплатить",
    oneTime: "разовый платёж",
    unlocks: "Что откроется",
    forDays: "{{count}} дн.",
    sandbox: "Тестовый режим PayPal: деньги не списываются.",
    processing: "Подтверждаем оплату…",
    rubNote: "Цена в витрине — {{rub}} ₽. PayPal не принимает рубли, поэтому оплата проходит в долларах; конвертирует ваш банк.",
    cardNote: "Pay with your PayPal account or a card.",
    doneTitle: "Оплата прошла",
    doneText: "«{{plan}}» уже открыт на вашем аккаунте.",
    doneButton: "Готово",
    pendingTitle: "Платёж обрабатывается",
    pendingText: "PayPal ещё проверяет платёж. Доступ откроется автоматически, как только он подтвердится, — обычно в течение нескольких минут.",
    methodWallet: "— кошелёк, если он у вас есть",
    methodCard: "Банковская карта",
    methodCardNote: "— Visa, Mastercard и другие, аккаунт PayPal не нужен",
    doneTextTelegram: "«{{plan}}» открыт на вашем аккаунте — и в Telegram тоже.",
    backToTelegram: "Вернуться в Telegram",
    listPrice: "Цена тарифа",
    creditUnused: "Зачёт за оставшиеся дни",
    upgradeNote: "Новый тариф начнётся сегодня на полный срок; неиспользованные дни текущего тарифа уже вычтены из цены.",
    stepUpNote: "Переход по полной цене. Оплаченные дни текущего тарифа не пропадут — новый срок добавится к ним.",
    yourPrice: "Ваша цена продления",
    priceKeptNote: "Вы продлеваете по цене, по которой купили, — она сохраняется, пока подписка не закончилась. После окончания продление будет по текущей цене.",
    err: {
      PAYMENTS_WEB_ONLY: "Оплата доступна только на сайте, не в Telegram.",
      PAYMENTS_DISABLED: "Онлайн-оплата сейчас выключена. Напишите администратору.",
      PLAN_NOT_PURCHASABLE: "Этот тариф нельзя купить онлайн. Напишите администратору.",
      PAYPAL_UNAVAILABLE: "PayPal сейчас не отвечает. Попробуйте ещё раз через минуту.",
      PAYMENT_DECLINED: "Платёж отклонён. Выберите другой способ оплаты в окне PayPal.",
      PAYMENT_NOT_APPROVED: "Платёж не был подтверждён в PayPal. Попробуйте ещё раз.",
      PAYMENT_NOT_COMPLETED: "PayPal не подтвердил платёж — деньги не списаны. Попробуйте ещё раз.",
      PAYMENT_CANCELLED: "Этот заказ заменён более новым — деньги не списаны. Откройте оплату заново.",
      PAYMENT_NOT_FOUND: "Заказ не найден. Откройте оплату заново.",
      SDK: "Не удалось загрузить PayPal. Проверьте соединение или отключите блокировщик рекламы.",
      generic: "Оплата не прошла. Попробуйте ещё раз.",
    },
  },
  planCard: {
    access: "Доступ на {{term}}",
    oneTime: "разовый платёж",
    payPaypal: "Оплатить ${{price}} · PayPal",
    writeAdmin: "Написать администратору",
    choose: "Выбрать",
    cardNoAccount: "Можно картой — без аккаунта PayPal",
    payInBrowser: "Оплатить в браузере · ${{price}}",
    browserHint: "Откроется сайт, вход выполнится сам. PayPal или банковская карта — аккаунт не нужен.",
    durYear: "Год",
    durMonths_one: "{{count}} месяц",
    durMonths_few: "{{count}} месяца",
    durMonths_many: "{{count}} месяцев",
    durMonths_other: "{{count}} месяца",
    duration: "Срок",
    forTerm: "за {{term}}",
    perMonth: "в месяц",
    yourPlan: "Ваш тариф",
    until: "до {{date}}",
    mostComplete: "Всё включено",
    includedInYours: "Уже входит в ваш тариф",
    upgradeFor: "Перейти за ${{price}}",
    renewFor: "Продлить · ${{price}}",
    creditLine: "Зачтём ${{credit}} за оставшиеся дни текущего тарифа",
    stepUpKeep: "Без зачёта: оплаченные дни текущего тарифа сохранятся, новый срок добавится к ним",
    launchTitle: "Цены запуска",
    launchPill: "цена запуска",
    priceKept: "Ваша цена сохранена: ${{price}} вместо ${{list}}, пока подписка активна",
    payByLink: "Карта · {{price}} ₽",
    pay: "Оплатить",
    renew: "Продлить",
    switchTo: "Перейти на этот тариф",
    methodsHint: "Visa и Mastercard — в любом способе оплаты, МИР и Белкарт — способ «Карта»",
  },
  payments: {
    title: "Оплаты онлайн",
    hint: "Последние оплаты через PayPal и по ссылке bePaid. Возврат делается в кабинете PayPal; доступ после возврата не снимается сам — решите в «Доступ к блокам».",
    empty: "Оплат пока нет.",
    liveTotal: "Реальных оплат: {{count}} · ${{total}}",
    showUnpaid: "Показать неоплаченные",
    hideUnpaid: "Скрыть неоплаченные",
    waiting_one: "{{count}} оплата по ссылке ждёт подтверждения",
    waiting_few: "{{count}} оплаты по ссылке ждут подтверждения",
    waiting_many: "{{count}} оплат по ссылке ждут подтверждения",
    waiting_other: "{{count}} оплаты по ссылке ждут подтверждения",
    confirm: "Подтвердить",
    reject: "Отклонить",
    rejectConfirm: "Отклонить эту оплату? Доступ выдан не будет.",
    status_cancelled: "Заменён новым заказом",
    status_credit_conflict: "Оплачен, доступ не выдан — зачёт уже использован",
    status_paid_cancelled: "Оплачен отменённый заказ — решите вручную",
    status_claimed: "Ждёт проверки",
    status_completed: "Оплачено",
    status_created: "Не оплачено",
    status_failed: "Не прошло",
    status_refunded: "Возврат",
    status_reversed: "Отменено банком",
  },
  handoff: {
    confirmEyebrow: "Вход из Telegram",
    confirmTitle: "Продолжить с этим аккаунтом?",
    confirmText: "Вы войдёте на сайт как",
    confirmReplace: "Текущий вход на этом сайте будет заменён.",
    confirmWarn: "Нажимайте «Да», только если вы сами открыли эту ссылку из BeeApp в Telegram и это ваш аккаунт. Покупки будут оформлены на него.",
    confirmYes: "Да, это мой аккаунт",
    confirmNo: "Нет, это не я",
    expiredTitle: "Ссылка для оплаты устарела",
    expiredText: "Она действует 10 минут и один раз. Вернитесь в Telegram и нажмите «Оплатить в браузере» ещё раз.",
  },
  report: {
    menuTitle: "Сообщить о проблеме",
    menuDesc: "Ошибка, неточность или что-то непонятно — напишите нам",
    eyebrow: "Обратная связь",
    title: "Что случилось?",
    intro: "Опишите, что не так или что непонятно. Сообщение получит команда BeeApp — вместе с данными о вашем аккаунте и устройстве, чтобы не переспрашивать.",
    categoryLabel: "Тема",
    cat_bug: "Ошибка в приложении",
    cat_unclear: "Непонятно или неточно",
    cat_payment: "Оплата и доступ",
    cat_other: "Другое",
    messageLabel: "Сообщение",
    placeholder_bug: "Что вы делали и что пошло не так? Например: нажала «Подобрать картридж» — экран завис.",
    placeholder_unclear: "Какой урок или экран и что именно непонятно или кажется неверным?",
    placeholder_payment: "Что оплатили и когда? Что видите сейчас вместо доступа?",
    placeholder_other: "Расскажите, что вы хотите сообщить.",
    addScreenshot: "Приложить скриншот",
    removeScreenshot: "Убрать скриншот",
    screenshot: "Скриншот",
    privacy: "Вместе с текстом отправятся ваше имя в Telegram или почта, статус подписки, модель устройства и язык.",
    send: "Отправить",
    doneTitle: "Спасибо, сообщение отправлено",
    doneText: "Команда посмотрит его в ближайшее время. Если понадобится уточнить, вам напишут.",
    doneButton: "Готово",
    tooMany: "Слишком много сообщений подряд. Попробуйте через 10 минут.",
    photoTooLarge: "Скриншот слишком большой — до 8 МБ.",
    failed: "Не удалось отправить. Проверьте соединение и попробуйте ещё раз.",
    close: "Закрыть",
    screenMenu: "Главное меню",
  },
  linkPay: {
    eyebrow: "Оплата картой",
    viaBepaid: "банковской картой",
    step1: "Страница оплаты открылась в новом окне — оплатите там.",
    step2: "Вернитесь сюда и нажмите «Я оплатил(а)».",
    step3: "Мы проверим поступление и откроем доступ — обычно в течение нескольких часов. Придёт сообщение в Telegram.",
    claim: "Я оплатил(а)",
    later: "Оплачу позже",
    claimedTitle: "Спасибо! Проверяем оплату",
    claimedText: "Как только платёж поступит, мы откроем доступ — обычно в течение нескольких часов. Пришлём сообщение в Telegram.",
    startFailed: "Страница оплаты открыта, но мы не успели записать заказ. Если оплатите — напишите нам через «Сообщить о проблеме».",
    claimFailed: "Не удалось отправить. Попробуйте ещё раз или напишите нам через «Сообщить о проблеме».",
  },
  payMethod: {
    forAccount: "Доступ откроется для аккаунта: {{name}}",
    eyebrow: "Оплата",
    title: "Как вам удобнее оплатить?",
    byRu: "Карта",
    byRuHow: "Для карт банков Беларуси и России",
    byRuBrands: "Visa,Mastercard,МИР,Белкарт",
    byRuPay: "Оплатить картой",
    byRuNote: "Доступ откроется после проверки платежа — обычно в течение нескольких часов.",
    byRuNoteAuto: "Спишется {{byn}} BYN (в белорусских рублях). Доступ откроется сразу после оплаты.",
    bynCredit: "Зачёт за неиспользованные дни: −{{credit}} BYN, к оплате {{due}} BYN",
    bynKept: "Продление по вашей цене: {{due}} BYN вместо {{list}} BYN",
    bepaidSandbox: "Тестовый режим: деньги не списываются (тестовая карта 4200 0000 0000 0000).",
    bepaidError: "Не удалось открыть оплату. Попробуйте ещё раз.",
    returnPaidTitle: "Оплата прошла",
    returnPaidText: "Доступ открыт — спасибо!",
    returnPendingTitle: "Проверяем оплату",
    returnPendingText: "Платёж ещё не подтверждён. Доступ откроется автоматически, как только он придёт.",
    returnFailedTitle: "Оплата не прошла",
    returnFailedText: "Деньги не списаны. Можно попробовать ещё раз или выбрать другой способ.",
    byRuNoLink: "Для этого тарифа ссылку на оплату картой РБ/РФ пришлём по запросу — обычно в течение нескольких часов.",
    requestLink: "Запросить ссылку на оплату",
    requestScreen: "Тарифы — оплата картой РБ/РФ",
    requestText: "Хочу оплатить тариф {{plan}} ({{term}}) картой РБ/РФ — пришлите, пожалуйста, ссылку на оплату.",
    world: "PayPal + Карта",
    worldHow: "Для карт банков Европы и других стран — аккаунт PayPal не нужен",
    worldBrands: "Visa,Mastercard,PayPal",
    worldPay: "Оплатить картой или PayPal",
    worldUnavailable: "Оплата через PayPal здесь недоступна.",
  },
};

export default ru;
